import { createContext, useContext } from 'react';
import moment from 'moment';

import { EMPTY_FUNCTION } from '../../../constants';
import { CALENDAR_MODE } from '../enums';
import { CalendarContextProps } from '../types';

export const CalendarContext = createContext<CalendarContextProps>({
  month: moment(),
  dates: [],
  mode: CALENDAR_MODE.SINGLE,
  onSelect: EMPTY_FUNCTION,
  onClickMonth: EMPTY_FUNCTION,
  onClickDay: EMPTY_FUNCTION,
});

export const useCalendarContext = () => useContext(CalendarContext) as CalendarContextProps;
